/* /sets and /sets?set=<code> — the browser half of the set pages.
 * The hub (pages/sets.php) rendered every set as a link, grouped by year: here, search, the type chips
 * (promos & tokens are a separate server page), "show older years", and the old #set/<code> links.
 * A set page rendered all its cards (the first 40 showing): here, find-by-name, rarity, color, sort,
 * "show more" and the card sheet. Filter state lives in the URL.
 */
import "../lib/site.js";
import "../lib/cards.js";
import "../lib/cardsheet.js";

(function () {
  "use strict";

  var KD = window.KD;
  var gaTimer = 0;
  function gaLater(name, params) { clearTimeout(gaTimer); gaTimer = setTimeout(function () { KD.ga(name, params); }, 1200); }
  function setUrl(params) {
    var p = new URLSearchParams();
    Object.keys(params).forEach(function (k) { if (params[k]) p.set(k, params[k]); });
    var qs = p.toString();
    try { history.replaceState(null, "", "/sets" + (qs ? "?" + qs : "")); } catch (e) { /* ignore */ }
  }
  var params = new URLSearchParams(location.search);

  // ---------------------------------------------------------------- the hub
  var yearsBox = KD.$("[data-years]");
  if (yearsBox) {
    // the old page kept the open set in the hash (/sets#set/fdn): send those links to the real set page
    var fromHash = function () {
      var h = (location.hash || "").match(/^#set\/([a-z0-9]{2,8})$/i);
      if (h) location.replace("/sets?set=" + h[1].toLowerCase());
      return !!h;
    };
    if (fromHash()) return;
    window.addEventListener("hashchange", fromHash);

    var years = KD.$$("[data-year]", yearsBox), tiles = KD.$$(".stile", yearsBox);
    var pager = KD.$("[data-pager]"), countEl = KD.$("[data-count]"), none = KD.$("[data-none]"), qEl = KD.$("[data-q]");
    var extrasView = /(^|&)type=extras(&|$)/.test(location.search.slice(1));
    tiles.forEach(function (t) { t._hay = (KD.$(".stile__body", t).textContent || "").toLowerCase(); });
    var hst = { q: (params.get("q") || "").trim().slice(0, 60), type: extrasView ? "extras" : (params.get("type") || ""), years: years.filter(function (y) { return !y.hidden; }).length };
    var STEP = 4;

    var paint = function () {
      var ws = hst.q.toLowerCase().split(/\s+/).filter(Boolean);
      var filtered = !!(ws.length || (hst.type && !extrasView)), total = 0, shownYears = 0;
      years.forEach(function (y, yi) {
        var n = 0;
        KD.$$(".stile", y).forEach(function (t) {
          var ok = (!hst.type || extrasView || t.getAttribute("data-g") === hst.type) && ws.every(function (w) { return t._hay.indexOf(w) !== -1; });
          t.hidden = !ok;
          if (ok) n++;
        });
        total += n;
        var show = n > 0 && (filtered || yi < hst.years);
        y.hidden = !show;
        if (show) shownYears++;
        var nEl = KD.$("[data-n]", y);
        if (nEl) nEl.textContent = n + (n === 1 ? " set" : " sets");
      });
      var hiddenYears = filtered ? 0 : years.filter(function (y, yi) { return yi >= hst.years && KD.$$(".stile", y).length; }).length;
      pager.innerHTML = hiddenYears ? '<a class="btn btn--ghost" href="/sets?all=1" data-more>Show older years <small>' + hiddenYears + " more</small></a>" : "";
      none.hidden = total > 0;
      countEl.textContent = total + (total === 1 ? " set" : " sets") + (ws.length ? " match “" + hst.q + "”" : "");
    };
    var syncHub = function (reason) {
      paint();
      if (!extrasView) setUrl({ q: hst.q, type: hst.type });
      gaLater("sets_filter", { reason: reason, q: hst.q, type: hst.type });
    };

    if (qEl) qEl.value = hst.q;
    if (hst.q || (hst.type && !extrasView)) paint();

    var qTimer = 0;
    if (qEl) qEl.addEventListener("input", function () { clearTimeout(qTimer); qTimer = setTimeout(function () { hst.q = qEl.value.trim().slice(0, 60); syncHub("search"); }, 140); });
    var form = KD.$("[data-ssearch]");
    if (form) form.addEventListener("submit", function (e) {
      e.preventDefault();
      clearTimeout(qTimer);
      hst.q = qEl.value.trim().slice(0, 60);
      syncHub("search");
      if (KD.mobile()) qEl.blur();
      var top = KD.$("[data-types]");
      if (top) window.scrollTo({ top: top.getBoundingClientRect().top + window.pageYOffset - 90, behavior: KD.reduce ? "auto" : "smooth" });
    });
    var chips = KD.$("[data-types]");
    if (chips) chips.addEventListener("click", function (e) {
      var a = e.target.closest("[data-type]");
      if (!a) return;
      var t = a.getAttribute("data-type");
      if (t === "extras" || extrasView) return; // promos & tokens are their own page
      e.preventDefault();
      hst.type = t;
      KD.$$("[data-type]", chips).forEach(function (x) { x.classList.toggle("is-on", x === a); });
      syncHub("type");
    });
    pager.addEventListener("click", function (e) {
      if (!e.target.closest("[data-more]")) return;
      e.preventDefault();
      hst.years += STEP;
      paint();
    });
    return;
  }

  // ---------------------------------------------------------------- one set
  var grid = KD.$("[data-cards]");
  if (!grid) { wireBuild(); return; }
  var cards = KD.$$(".scard", grid);
  var setCode = (params.get("set") || "").toLowerCase();
  var RNAME = { m: "Mythic rare", r: "Rare", u: "Uncommon", c: "Common", s: "Special" };
  cards.forEach(function (t, i) {
    t._i = i;
    t._name = (KD.$(".scard__name", t).textContent || "").trim();
    t._low = t._name.toLowerCase();
    t._p = t.hasAttribute("data-p") ? parseFloat(t.getAttribute("data-p")) : -1;
  });
  var pagerEl = KD.$("[data-pager]"), countLine = KD.$("[data-count]"), noneEl = KD.$("[data-none]"), q = KD.$("[data-q]");
  var sortSel = KD.$("[data-sort]"), rarity = KD.$("[data-rarity]"), colorsBox = KD.$("[data-colors]");
  var partialNote = countLine ? countLine.textContent : "";
  var STEP_CARDS = 40;
  var st = {
    q: (params.get("q") || "").trim().slice(0, 60),
    r: /^[mrucs]$/.test(params.get("r") || "") ? params.get("r") : "",
    colors: "WUBRGC".split("").filter(function (c) { return (params.get("c") || "").toUpperCase().indexOf(c) !== -1; }).join(""),
    sort: ["price", "name"].indexOf(params.get("sort")) !== -1 ? params.get("sort") : "num",
    shown: STEP_CARDS
  };
  function isDefault() { return !st.q && !st.r && !st.colors && st.sort === "num"; }
  function imgUrl(id) { return /^[0-9a-f-]{36}$/.test(id) ? "https://cards.scryfall.io/normal/front/" + id[0] + "/" + id[1] + "/" + id + ".jpg" : ""; }
  // tiles past the first 40 come without an <img> (a lighter page): add it the first time the tile shows
  function withImg(t) {
    if (t._img || KD.$("img", t)) { t._img = true; return; }
    t._img = true;
    var im = document.createElement("img");
    im.src = imgUrl(t.getAttribute("data-i"));
    im.alt = t._name;
    im.width = 488; im.height = 680;
    im.loading = "lazy"; im.decoding = "async";
    t.insertBefore(im, t.firstChild);
  }

  function render() {
    var ws = st.q.toLowerCase().split(/\s+/).filter(Boolean), cols = st.colors.split("").filter(Boolean);
    var list = cards.filter(function (t) {
      if (st.r && t.getAttribute("data-r") !== st.r) return false;
      if (cols.length) {
        var c = t.getAttribute("data-c") || "";
        if (!cols.some(function (x) { return x === "C" ? c === "" : c.indexOf(x) !== -1; })) return false;
      }
      return ws.every(function (w) { return t._low.indexOf(w) !== -1; });
    });
    list.sort(function (a, b) {
      if (st.sort === "price") return b._p - a._p || a._i - b._i;
      if (st.sort === "name") return a._low.localeCompare(b._low) || a._i - b._i;
      return a._i - b._i;
    });
    var frag = document.createDocumentFragment(), set = {};
    list.forEach(function (t, i) { set[t._i] = 1; t.hidden = i >= st.shown; if (!t.hidden) withImg(t); frag.appendChild(t); });
    cards.forEach(function (t) { if (!set[t._i]) { t.hidden = true; frag.appendChild(t); } });
    grid.appendChild(frag);
    var left = list.length - st.shown;
    var extra = KD.$("a.linkbtn", pagerEl);
    pagerEl.innerHTML = (left > 0 ? '<button class="btn btn--ghost" type="button" data-more>Show more cards <small>' + left + " more</small></button>" : "") + (extra ? extra.outerHTML : "");
    noneEl.hidden = list.length > 0;
    grid.hidden = !list.length;
    countLine.textContent = isDefault() ? partialNote : list.length + (list.length === 1 ? " card" : " cards") + (st.q ? " match “" + st.q + "”" : "");
  }
  function sync(reason) {
    st.shown = STEP_CARDS;
    render();
    setUrl({ set: setCode, q: st.q, r: st.r, c: st.colors, sort: st.sort === "num" ? "" : st.sort });
    gaLater("set_filter", { set: setCode, reason: reason });
  }
  function paintControls() {
    KD.$$("[data-r]", rarity).forEach(function (b) { b.classList.toggle("is-on", b.getAttribute("data-r") === st.r); });
    KD.$$("[data-color]", colorsBox).forEach(function (b) {
      var on = st.colors.indexOf(b.getAttribute("data-color")) !== -1;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", String(on));
    });
    if (sortSel) sortSel.value = st.sort;
    if (q) q.value = st.q;
  }
  paintControls();
  if (!isDefault()) render();

  var qt = 0;
  if (q) q.addEventListener("input", function () { clearTimeout(qt); qt = setTimeout(function () { st.q = q.value.trim().slice(0, 60); sync("search"); }, 140); });
  if (rarity) rarity.addEventListener("click", function (e) {
    var b = e.target.closest("[data-r]");
    if (!b) return;
    st.r = b.getAttribute("data-r");
    paintControls();
    sync("rarity");
  });
  if (colorsBox) colorsBox.addEventListener("click", function (e) {
    var b = e.target.closest("[data-color]");
    if (!b) return;
    var c = b.getAttribute("data-color");
    st.colors = st.colors.indexOf(c) !== -1 ? st.colors.replace(c, "") : "WUBRGC".split("").filter(function (x) { return x === c || st.colors.indexOf(x) !== -1; }).join("");
    paintControls();
    sync("colors");
  });
  if (sortSel) sortSel.addEventListener("change", function () { st.sort = sortSel.value; sync("sort"); });
  pagerEl.addEventListener("click", function (e) {
    if (!e.target.closest("[data-more]")) return;
    st.shown += STEP_CARDS;
    render();
  });
  var reset = KD.$("[data-reset]");
  if (reset) reset.addEventListener("click", function () { st.q = ""; st.r = ""; st.colors = ""; st.sort = "num"; paintControls(); sync("reset"); });

  // ---------------------------------------------------------------- card sheet
  function openCard(el) {
    var id = el.getAttribute("data-i"), tile = KD.$('.scard[data-i="' + id + '"]', grid) || el;
    var name = tile._name || (KD.$(".drow__name", el) || el).textContent.trim();
    var r = tile.getAttribute("data-r") || "";
    var price = tile.hasAttribute("data-p") ? tile.getAttribute("data-p") : "N/A";
    KD.cardx.openLazy({ id: id, name: name, imageUrl: imgUrl(id), price: price }, {
      note: '<p class="hint">' + (RNAME[r] || "") + (setCode ? " · " + setCode.toUpperCase() : "") + "</p>",
      actions: '<a class="btn btn--ghost btn--sm" href="/cards-pricing?q=' + encodeURIComponent('!"' + name.split(" // ")[0] + '"') + '&prints=1">' + KD.icon("search") + "<span>All printings &amp; prices</span></a>"
    });
    KD.ga("set_card_open", { set: setCode, card: name });
  }
  document.addEventListener("click", function (e) {
    var el = e.target.closest("[data-i]");
    if (el && el.closest("[data-cards], [data-cardzone]")) openCard(el);
  });

  wireBuild();

  function wireBuild() {
    var b = KD.$("[data-build-set]");
    if (b) b.addEventListener("click", function () {
      KD.stashPrompt(b.getAttribute("data-prompt"), b.getAttribute("data-format") || "commander");
      b.href = KD.buildUrl();
      KD.ga("set_build", { set: setCode || "" });
    });
  }
})();
